module.exports = __webpack_public_path__ + "img/products-banner-m.04bad301.jpg";